import { action } from "typesafe-actions";
import { IReports, IReportsRecord } from "./types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { saveLoaderProgress, showMessage } from "../messages/messagesActions";
import { api } from "../../api/api";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";

export const FETCH_REPORTS_LIST_PROGRESS = "FETCH_REPORTS_LIST_PROGRESS";
export const FETCH_REPORTS_LIST_SUCCESS = "FETCH_REPORTS_LIST_SUCCESS";
export const FETCH_REPORTS_LIST_FAILED = "FETCH_REPORTS_LIST_FAILED";

export const fetchReportsListProgress = () =>
  action(FETCH_REPORTS_LIST_PROGRESS);
export const fetchReportsListSuccess = (
  data: IReports[],
  singleReport: IReports,
  totalRecords: number,
  totalamount: number

) =>
  action(FETCH_REPORTS_LIST_SUCCESS, {
    data,
    singleReport,
    totalRecords,
    totalamount,
  });
export const fetchReportsListFailed = () => action(FETCH_REPORTS_LIST_FAILED);

export const fetchReportsListAsync =
  (
    date: IDataTableV2DateState["dates"],
    organizationUUID: string,
    courseUUID?: string,
    batch?: string,
    acedmicYear?: number
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchReportsListProgress());

      let url = "";
      if (organizationUUID) {
        url += `&organizations_uuid=${organizationUUID}`;
      }
      if (courseUUID) {
        url += `&courses_uuid=${courseUUID}`;
      }
      if (batch) {
        url += `&batch=${batch}`;
      }
      if (acedmicYear) {
        url += `&academic_year=${acedmicYear}`;
      }
      const res = await api.get(
        `report/get-payType-wise-data?&from_date=${date.fromDate}&to_date=${date.toDate}` +
          url
      );

      const data: IReports[] = res.data.data.transactions;
      const totalamount = res.data.data.totalamount;
      const singleReport = res.data.data.transactions[0];
      const totalRecords = res.data.totalRecords;

      dispatch(fetchReportsListSuccess(data, singleReport, totalRecords, totalamount));
    } catch (error: any) {
      dispatch(fetchReportsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: error.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

  // export const fetchReportsListAsync =
  // (
  //   date: IDataTableV2DateState["dates"],
  //   organizationUUID: string,
  //   courseUUID?: string,
  //   batch?: string,
  //   acedmicYear?: number
  // ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  // async (dispatch, getState) => {
  //   try {
  //     dispatch(fetchReportsListProgress());

  //     let url = "";
  //     if (organizationUUID) {
  //       url += `&organizations_uuid=${organizationUUID}`;
  //     }
  //     if (courseUUID) {
  //       url += `&courses_uuid=${courseUUID}`;
  //     }
  //     if (batch) {
  //       url += `&batch=${batch}`;
  //     }
  //     if (acedmicYear) {
  //       url += `&academic_year=${acedmicYear}`;
  //     }
  //     const res = await api.get(
  //       `report/get-paytype-total-fee-record?`+
  //         url
  //     );

  //     const data: IReportsRecord[] = res.data.data;
  //     const singleReport = res.data.data.transactions[0];
  //     const totalRecords = res.data.totalRecords;

  //     dispatch(fetchReportsListSuccess(data, singleReport, totalRecords));
  //   } catch (error: any) {
  //     dispatch(fetchReportsListFailed());
  //     dispatch(
  //       showMessage({
  //         type: "error",
  //         message: error.response.data.message,
  //         displayAs: "snackbar",
  //       })
  //     );
  //   }
  // };
  export const CLEAR_REPORTS_STATE = "CLEAR_REPORTS_STATE";
export const CLEAR_REPORTS= "CLEAR_REPORTS";

export const clearReportsState = () => action(CLEAR_REPORTS_STATE);
export const clearReports = () => action(CLEAR_REPORTS);

